import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@sharedModule/material/material.module';
import { HeaderComponent } from '../header/header.component';
import { SidenavComponent } from '../sidenav/sidenav.component';

interface SideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-main-layout',
  standalone: true,
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  imports: [
    CommonModule,
    HeaderComponent,
    SidenavComponent,
    RouterModule,
    MaterialModule,
  ],
})
export class MainLayoutComponent implements OnInit {
  sideBarOpen = true;
  isSideNavCollapsed = false;
  screenWidth = 0;
  collapsed = true;

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
  }

  onToggleSideNav(data: SideNavToggle): void {
    this.screenWidth = data.screenWidth;
    this.isSideNavCollapsed = data.collapsed;
    this.collapsed = data.collapsed;
  }

  sideBarToggler(): void {
    this.sideBarOpen = !this.sideBarOpen;
  }
}
